import { useEffect, useState } from 'react';

/**
 * Defers showing a loading state until a minimum delay has passed.
 * Useful for avoiding spinner flashes on fast loads.
 *
 * @param isLoading - The actual loading state
 * @param delayMs - Minimum time before showing loading state (default: 1500ms)
 * @returns boolean - Whether to show the loading indicator
 */
const useDeferredLoading = (isLoading: boolean, delayMs = 1500): boolean => {
  const [delayElapsed, setDelayElapsed] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      // Reset when loading stops - this is intentional cascading behavior
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setDelayElapsed(false);
      return;
    }

    const timer = setTimeout(() => {
      setDelayElapsed(true);
    }, delayMs);

    return () => clearTimeout(timer);
  }, [isLoading, delayMs]);

  return isLoading && delayElapsed;
};

export default useDeferredLoading;
